export default __webpack_public_path__ + "static/media/Rupees.c7f054e9.svg";